import { createMiddleware } from '@shared/redux';
import {
    CAMPAIGN_TABLE_NOTIFICATIONS,
    EDIT_SEGMENT_MODAL_REQUEST_FAILED,
    EDIT_SEGMENT_MODAL_REQUEST_SUCCEEDED,
} from '@domain/segments';
import { showErrorToast, showSuccessToast } from '@shared/toasts';

const { CREATE_TAGS_GROUP, UPDATE_TAGS_GROUP } = CAMPAIGN_TABLE_NOTIFICATIONS;

export const segmentsModalMiddleware = createMiddleware({
    [EDIT_SEGMENT_MODAL_REQUEST_SUCCEEDED]: (state, action) => {
        const isCreatingSegment = !action.requestAction.payload.segment.id;
        const message = isCreatingSegment
            ? CREATE_TAGS_GROUP.SUCCESSFUL : UPDATE_TAGS_GROUP.SUCCESSFUL;

        return showSuccessToast({ message });
    },
    [EDIT_SEGMENT_MODAL_REQUEST_FAILED]: () => [
        showErrorToast({
            message: CAMPAIGN_TABLE_NOTIFICATIONS.CREATE_TAGS_GROUP.ERROR,
        }),
    ],
});
